<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Audit Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Audit Trail" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read customer'">
      <template #gated-content>
        <customer-card :customer="customer" />

        <div>
          <h3>
            Change Log
            <b-button class="float-right" variant="success" :to="`/customer/${customer_id}/audit-trail-history`">
              View History
            </b-button>
          </h3>
        </div>
        <AuditChangeLogTable
          :model="customer"
        />

        <h3>Relations</h3>
        <AuditRelationTable
          :model="customer"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import CustomerCard from '@/components/crm/customer/CustomerCard'
import AuditChangeLogTable from '@/components/shared/audit/AuditChangeLogTable'
import AuditRelationTable from '@/components/shared/audit/AuditRelationTable'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import CustomerModel from '@/models/crm/CustomerModel'

export default {
  name: "CustomerAuditTrail",
  components: {
    PermissionAlertGate,
    CustomerCard,
    AuditChangeLogTable,
    AuditRelationTable,
    BasicHeading,
    HeaderButtonGroup
  },
  mixins: [ToastNotifications],
  data () {
    return {
      loading: true,
      customer: null,
      customer_id: this.$route.params.customer_id || null
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/customer/${this.customer_id}`,
            title: "View customer",
            variant: "info",
          }
        ]
      }
    },
  },
  async created () {
    this.loading = true

    this.customer = new CustomerModel({ id: this.customer_id })

    const params = {}
    params.connection = ['auditCreatedBy', 'auditUpdatedBy']

    this.customer.fetch({ params }).then(() => {
      this.loading = false
    })
  },
}
</script>
